import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-access-dialog',
  templateUrl: './access-dialog.component.html',
  styleUrls: ['./access-dialog.component.scss'],
})
export class AccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  accept(boolean: boolean = true) {
    this.dialogRef.close(boolean);
  }
}
